import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Reinvent Your Digital Infrastructure with{" "}
              <span>Cloud Consultancy Services</span>
            </h2>
            <p>
              Access the top cloud deployment strategists at our tech-focused
              cloud consulting company and boost the current operational
              capabilities for quicker time-to-market, efficient
              problem-solving, and service expansion.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Multi-Cloud Strategy</h6>
                <p>
                  Distribute workloads for redundancy and performance across
                  AWS, Azure, GCP, and more.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Disaster Recovery & Backup</h6>
                <p>
                  Minimize downtime and data loss with tailored recovery plans
                  and automated backups.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Serverless Architecture</h6>
                <p>
                  Deploy scalable applications with AWS Lambda, Azure Functions,
                  and Google Cloud Functions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>DevOps Automation</h6>
                <p>
                  Speed up software delivery with CI/CD pipelines and automated
                  testing.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cloud-Native Application</h6>
                <p>
                  Develop scalable applications using microservices, containers,
                  and Kubernetes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>AI & ML Integration</h6>
                <p>
                  Incorporate AI/ML for data-driven decisions using AWS
                  SageMaker, Azure ML, and Google AI Platform.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
